import { memo } from "react";
import { useCart } from "../../context/CartContext";
import { useWishlist } from "../../context/WishlistContext";

// Price ko hamesha sahi number mein convert karta hai
// "Rs. 2,500" -> 2500 | 2500 -> 2500
function toNumericPrice(price) {
  if (typeof price === "number") return price;
  if (!price) return 0;

  const match = String(price).match(/[\d,]+(\.\d+)?/);
  if (!match) return 0;

  return Number(match[0].replace(/,/g, "")) || 0;
}

function ProductCard({ product, onNavigate }) {
  const { addItem } = useCart();
  const { toggleItem, isWishlisted } = useWishlist();
  const liked = isWishlisted(product.id);
  const isAvailable = product.status === "available";

  const handleAddToCart = (e) => {
    e.stopPropagation();

    const cartItem = {
      ...product,
      price: toNumericPrice(product.price),
    };

    addItem(cartItem);
    onNavigate && onNavigate("/cart");
  };

  const handleWishlist = (e) => {
    e.stopPropagation();
    toggleItem(product.id);
  };

  const handleNavigateToProducts = () => {
    onNavigate && onNavigate("/products");
  };

  return (
    <article className="product-card" onClick={handleNavigateToProducts}>
      <div className="product-card__image-wrap">
        <img src={product.image} alt={product.name} loading="lazy" />
        <span
          className={`product-card__badge ${
            product.badge === "NEW IN" ? "is-new" : "is-soon"
          }`}
        >
          {product.badge}
        </span>
      </div>
      <h3 className="product-card__name">{product.name}</h3>
      <div className="product-card__footer">
        <span className="product-card__price">
          {isAvailable
            ? `${product.currency} ${product.price.toLocaleString()}`
            : "Coming Soon"}
        </span>
        {isAvailable && (
          <div className="product-card__actions">
            <button
              className={`icon-btn ${liked ? "is-active" : ""}`}
              onClick={handleWishlist}
              aria-label="Toggle wishlist"
            >
              ♥
            </button>
            <button
              className="icon-btn"
              onClick={handleAddToCart}
              aria-label="Add to cart"
            >
              🛒
            </button>
          </div>
        )}
      </div>
    </article>
  );
}

export default memo(ProductCard);